import React from 'react';
import styled from 'styled-components';
import { CATEGORY_INGREDIENTS, EATING_TAGS } from '../../../../constants/appConstants';

const categoryTagsInfo = [
  {
    name: 'Приёмы пищи:',
    categoryId: EATING_TAGS,
  },
  {
    name: 'Категории продуктов:',
    categoryId: CATEGORY_INGREDIENTS,
  },
];

const Tags = ({ tags, checkIncludesTags, handleInput }) => {
  if (!tags || !tags.length) return null;

  return (
    <TagsBlock>
      {categoryTagsInfo.map((categoryTags) => {
        const categoryTagsData = tags.filter((tag) => tag.category_id === categoryTags.categoryId);
        return (
          <CategoryTagsWrap key={categoryTags.name + categoryTags.categoryId}>
            <CategoryTagsTitle>
              {categoryTags.name}
              <Message>*</Message>
            </CategoryTagsTitle>
            {categoryTagsData.map((tag, i) => {
              const isTagChecked = checkIncludesTags(tag.tag_id);
              return (
                <TagsItem key={tag.tag_id + tag.name}>
                  <TagLabel>
                    <TagCheckbox
                      name={i}
                      value={tag.tag_id}
                      type="checkbox"
                      checked={isTagChecked ? 'checked' : ''}
                      // checked={dish.tags ? checkIncludesTags(tag.name) ? "checked" : "" : ""}
                      onChange={handleInput}
                    />
                    {tag.name}
                  </TagLabel>
                </TagsItem>
              );
            })}
          </CategoryTagsWrap>
        );
      })}
    </TagsBlock>
  );
};

export default Tags;

const TagsBlock = styled.div`
  width: 90%;
  margin: 10px 5%;
  display: flex;
  justify-content: space-start;
  flex-direction: row;
  flex-wrap: wrap;
`;

const CategoryTagsTitle = styled.div`
  font-size: 16px;
  margin: 10px 0;
  width: 100%;
  font-weight: bold;
`;

const TagsItem = styled.div`
  min-width: 15%;
  display: inline-block;
  margin: 6px 4%;
  font-size: 12px;
  @media (max-width: 1010px) {
    width: 40%;
  }
`;

const TagCheckbox = styled.input`
  margin-right: 5px;
`;

const TagLabel = styled.label`
  cursor: pointer;
`;

const CategoryTagsWrap = styled.div`
  width: 100%;
`;

const Message = styled.span`
  display: inline-block;
  color: #ea1b00;
  margin: 0 3px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/Tags.jsx